:host(c-link) {
  /**
   * @prop --_c-link-color: Link color
   * @prop --_c-link-hover: Link hover background color
   */
  --_c-link-color: var(--c-link-color, var(--c-info-700));
  --_c-link-hover: var(--c-link-hover, var(--c-accent-200));

  a {
    --_c-link-icon-margin: 8px;

    align-items: center;
    background-color: var(--c-transparent);
    color: var(--_c-link-color);
    cursor: pointer;
    display: inline-flex;
    font-size: inherit;
    gap: var(--_c-link-icon-margin);
    justify-content: start;
    text-decoration: none;
    transition: background-color 0.3s ease-in-out;

    &:hover {
      background-color: var(--_c-link-hover);
    }

    @supports selector(:focus-visible) {
      &:focus {
        outline: none;
      }
    }

    &:focus-visible {
      outline: 2px var(--_c-link-color) solid;
      outline-offset: 4px;
      border-radius: 2px;
    }
  }

  a.underline {
    text-decoration: underline;
  }
}
